import { OidcIdentityProvidersApi } from '../../../../api-client';
import { useMutation, UseMutationResult } from 'react-query';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../../common/types/errorRespose';
import { UseMutationOptions } from 'react-query/types/react/types';
import { getApiConfiguration } from '../../../../common';

type UseDisableOidcProvider = (
  options?: Omit<UseMutationOptions<AxiosResponse<void>,
    ErrorResponse,
    { id: string }>,
    'mutationFn'>,
) => UseMutationResult<
  AxiosResponse<void>,
  ErrorResponse,
  { id: string }
>;

export const useDisableOidcProvider: UseDisableOidcProvider = (
  options,
) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  const oidcIdentityProvidersApi = new OidcIdentityProvidersApi(getApiConfiguration());
  return useMutation(
    ({ id }: { id: string }) =>
      oidcIdentityProvidersApi.disableOidcProvider(id, tenantId),
    options,
  );
};
